import type { IComponentController, IScope } from "angular";
import { size } from "lodash";
import { SearchResultType } from "App/Modules/Models";
import type { IModalService } from "App/Modules/Services";

export class ExtendedSearchOverviewComponentController implements IComponentController {
    public static $inject = ["$scope", "mmModalService"];

    public onCloseModal: () => void;

    public searchString: string;

    public SearchResultType = SearchResultType;

    public noResultsForType: { [type: number]: boolean };

    public typingOffset = 1;

    constructor(private readonly $scope: IScope, private readonly modalService: IModalService) {}

    public $onInit() {
        this.noResultsForType = {};

        this.$scope.$on("$locationChangeStart", () => {
            this.onCloseModal();
        });

        this.modalService.onCloseAll(() => {
            this.onCloseModal();
        });
    }

    public shouldHideResults() {
        return size(this.searchString) <= this.typingOffset;
    }

    public areNoResults() {
        return Object.keys(this.noResultsForType)
            .map((key) => this.noResultsForType[key as any])
            .every((val) => val);
    }
}
